"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue3_compat_1 = require("@/client/vue3-compat");
exports.default = (0, vue3_compat_1.defineComponent)({
    name: 'ShiftAresGlobalParameters',
    props: {
        playerinput: {
            type: Object,
            required: true,
        },
        onsave: {
            type: Function,
            required: true,
        },
        showsave: {
            type: Boolean,
        },
        showtitle: {
            type: Boolean,
        },
    },
    data() {
        const hazardData = this.playerinput.aresData.hazardData;
        return {
            hazardData: hazardData,
            lowOceanDelta: 0,
            highOceanDelta: 0,
            temperatureDelta: 0,
            oxygenDelta: 0,
        };
    },
    methods: {
        saveData() {
            const response = {
                lowOceanDelta: this.lowOceanDelta,
                highOceanDelta: this.highOceanDelta,
                temperatureDelta: this.temperatureDelta,
                oxygenDelta: this.oxygenDelta,
            };
            this.onsave({ type: 'aresGlobalParameters', response });
        },
    },
    computed: {
        ADJUSTMENT_RANGE() {
            return [-1, 0, 1];
        },
    },
});
